import React, { useEffect, useRef, useState } from "react";

interface DescriptionCellProps {
  value: string | null;
  onViewMore: (description: string) => void;
}

const DescriptionCell = ({ value, onViewMore }: DescriptionCellProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowingTwoLines, setIsOverflowingTwoLines] = useState(false);
  const isNullValue = value == null;

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const lineHeight = Number.parseFloat(getComputedStyle(element).lineHeight) || 20;
      const twoLineHeight = lineHeight * 2;
      setIsOverflowingTwoLines(element.scrollHeight > twoLineHeight + 2);
    }
  }, [value]);

  if (isNullValue) {
    return (
      <div className="descriptionText nullDescription">
        Dados não finalizados. Complete para visualizar.
      </div>
    );
  }

  return (
    <div
      className="descriptionText"
      style={{
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        marginRight: "-10px",
      }}
    >
      <div
        ref={textRef}
        style={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          flexGrow: 1,
          cursor: "default",
          wordBreak: "break-word",
          lineHeight: "1.2em",
        }}
      >
        {value}
      </div>

      {isOverflowingTwoLines && (
        <button
          type="button"
          className="text-plus"
          onClick={() => onViewMore(value)}
          aria-label="Ver mais"
        >
          Ver mais
        </button>
      )}
    </div>
  );
};

export default DescriptionCell;
